<template>
  <v-dialog
    v-model="dialog"
    persistent
    :max-width="maxWidth"
  >
    <v-card>
      <v-card-title>
        <h2>{{ title }}</h2>

        <v-spacer />

        <v-icon
          aria-label="Close"
          @click="cancel"
        >
          mdi-close
        </v-icon>
      </v-card-title>

      <v-card-text class="pb-6 pt-6 text-center black--text">
        {{ content }}
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          class="mr-3"
          @click="ok"
        >
          확인
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'InfoDialog',
    props: {
      title: {
        type: String,
      },
      content: {
        type: String,
      },
      dialog: {
        type: Boolean,
        default: false,
      },
      toParent: {
        type: Function,
      },
      maxWidth: {
        type: Number,
        default: 300,
      },
    },
    methods: {
      ok () {
        this.toParent('ok')
      },
      cancel () {
      },
    },
  }
</script>

<style scoped>

</style>
